import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators";
import { ClientSettings } from "src/model/class/client-settings";
import {
  ClientSettingsStoreAction,
  StorageNativeStoreAction,
} from "src/components/shared-components/enum/enumStoreAction";
import { AppState } from "src/model/interface/app-state";
import { TranslationService } from "src/service/translation.service";
import {
  clientSettingCreateObjectAction,
  clientSettingInitCompleteAction,
  clientSettingSetLanguageDeviceAction,
} from "../actions/client-settings.actions";

/**
 * Handle client setting effect
 */
@Injectable()
export class ClientSettingsEffects {
  constructor(
    private _actions$: Actions,
    private _translateService: TranslateService,
    private _translationService: TranslationService
  ) { }

  /**
   * Effet attached to ngrx store init, then start init initialization
   */
  public clientSettingStarInit = createEffect(() =>
    this._actions$.pipe(
      ofType(StorageNativeStoreAction.NSIS_APP_HYDRATED),
      map((action: any) => {
        const store: AppState = action.payload;
        if (store.clientSettings) {
          const fullClientSettings = new ClientSettings({ ...store.clientSettings });

          return clientSettingInitCompleteAction({
            clientSettings: fullClientSettings,
          });
        } else {
          return clientSettingCreateObjectAction();
        }
      })
    )
  );

  /**
   * Client settings init object
   */
  public clientSettingObjectCreateEffect = createEffect(() =>
    this._actions$.pipe(
      ofType(ClientSettingsStoreAction.CLIENT_SETTINGS_CREATE_OBJECT),
      map((action) => new ClientSettings()),
      map((clientSettings: ClientSettings) =>
        clientSettingSetLanguageDeviceAction({ clientSettings })
      )
    )
  );

  /**
   * Set client settings language by device language and supported language
   */
  public clientSettinsSetLanguageeEffect = createEffect(() =>
    this._actions$.pipe(
      ofType(ClientSettingsStoreAction.CLIENT_SETTINGS_SET_LANGUAGE_BY_DEVICE),
      map((action: any) => {

        const deviceLanguage: string = this._translateService.getBrowserLang();
        const clientSettings = new ClientSettings({ ...action.clientSettings });

        if (
          this._translationService.checkIfDeviceLanguageIsSupportedBySystem(
            this._translateService.getBrowserLang()
          )
        ) {
          clientSettings.language = deviceLanguage;
        } else {
          /*FALLBACK: 
            If current Device Language is NOT present among the fully localized languages for the app (IT, EN, FR, DE, ES), then
            dset App language to "EN" (English)
          */

          clientSettings.language = "en";
        }

        return clientSettings;
      }),
      map((clientSettings: ClientSettings) =>
        clientSettingInitCompleteAction({ clientSettings })
      )
    )
  );
}
